import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import { TOptSelect } from "@/features/financas/views/Indicadores/store/dashboard/types";
import { IPreferencesUser } from "@/features/financas/views/Indicadores/@types/type";
import { defineStore } from "pinia";

export const idStore = "userPreferences";

export interface IUserPreferenceStore {
  preferences: IPreferencesUser[];
}

export const useUserPreferencesStore = defineStore(idStore, {
  state: (): IUserPreferenceStore => ({
    preferences: []
  }),
  actions: {
    setPreferences(preferences: IPreferencesUser[] | []) {
      if (!preferences) return (this.preferences = []);

      const preferencesComId = preferences.map((item: IPreferencesUser) => {
        const newPreferences = item.preferences.map((preference) => {
          const widgetId =
            EWidgets[preference.displayName as keyof typeof EWidgets];
          if (widgetId !== undefined) {
            return {
              ...preference,
              id: widgetId
            };
          } else {
            return preference;
          }
        });

        return {
          ...item,
          preferences: newPreferences
        };
      });

      this.preferences = preferencesComId;
    },
    updateDefault(preferenceList: IPreferencesUser[]) {
      this.setPreferences(preferenceList);
    }
  },
  getters: {
    preferencesOpt(): TOptSelect[] | [] {
      if (!this.preferences) return [];

      return this.preferences.map((preference) => {
        return {
          label: preference.name,
          value: preference._id?.toString() || ""
        };
      });
    }
  }
});
